export const formataCnpj = (cnpj) => {
  return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
}

export const formataMoeda = (valor, options='currency') => {
  if(!valor || isNaN(valor)) {
    valor = 0
  }

  let config = { style: 'currency', currency: 'BRL' };

  if(options !='currency'){
    config = {
      minimumFractionDigits: 2,
      maximumFractionDigits: 4
    }
  }

  return Number(valor).toLocaleString('pt-BR', config);
}

export const formataNumero = (numero, casasDecimais = 2) =>{
  if (numero === null || numero === undefined) {
    return '';
  }
  return parseFloat(numero.toString()).toFixed(casasDecimais).replace('.', ',');
}

  /**
   * @param {string} value
   * @returns {number}
   */
  export const parseNumberPtBR = (value) => {
    const normalized = value.replace(',', '.');

    return parseFloat(normalized) || 0;
  }

export const formataCPF = (cpf) => {
  if(!cpf) {
    return ''
  }
  return cpf.replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d)/, '$1.$2')
            .replace(/(\d{3})(\d{1,2})$/, '$1-$2');
}

export const formatDate = (dateString, format) => {
  if(window.t) {
    format = format || window.t('date.formats.default')
  }

  if (!dateString || !format) return '';
  
  try {
    const date = /^\d{4}-\d{2}-\d{2}$/.test(dateString)
      ? new Date(dateString + 'T00:00:00')
      : new Date(dateString);
    
    if (isNaN(date.getTime())) {
      console.warn('Data inválida:', dateString);
      return 'invalid date';
    }

    return formatDateByPattern(date, format);
  } catch (error) {
    console.error('Erro ao formatar data:', error);
    return dateString;
  }
}

function formatDateByPattern(date, pattern) {
  const day = date.getDate().toString().padStart(2, '0');
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const year = date.getFullYear();
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const seconds = date.getSeconds().toString().padStart(2, '0');

  return pattern
    .replace(/%d/g, day)
    .replace(/%m/g, month)
    .replace(/%Y/g, year)
    .replace(/%H/g, hours)
    .replace(/%M/g, minutes)
    .replace(/%S/g, seconds);
}

export function formataTelefoneIntercom(telefone) {
  if (!telefone) return '';

  const ddd = telefone.substring(2, 4);
  const primeiraParte = telefone.substring(4, 8);
  const segundaParte = telefone.substring(8);
  return `(${ddd}) ${primeiraParte}-${segundaParte}`;
}

export function formatTime(ms) {
  const totalSeconds = Math.floor(ms / 1000)

  const hours = Math.floor(totalSeconds / 3600)
  const minutes = Math.floor((totalSeconds % 3600) / 60)
  const seconds = totalSeconds % 60

  const pad = (n) => String(n).padStart(2, '0')

  return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
}
